import { styled } from '@mui/material/styles';
import { Box, Dialog } from '@mui/material';

export const RcmDialog = styled(Dialog)({
  zIndex: '1300 !important',

  '& .MuiPaper-root': {
    width: '90%',
    maxWidth: 600,
    height: '90vh',
  },
});

export const RcmContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

export const RcmInputContainer = styled(Box)({
  flex: 1,
  overflow: 'auto',
  marginTop: '66px',
});
